var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDomains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0047 18.9596C14.9501 18.9571 18.9584 14.9473 18.9584 10.0013C18.9584 5.05375 14.9476 1.04297 10.0001 1.04297C5.05253 1.04297 1.04175 5.05375 1.04175 10.0013C1.04175 14.9473 5.05003 18.9571 9.99546 18.9596L10.0001 18.9597L10.0047 18.9596ZM8.58012 2.42348C5.20084 3.05275 2.59672 5.88667 2.31672 9.3763H6.06865C6.23631 6.86304 7.11003 4.45401 8.58012 2.42348ZM11.42 2.42348C12.8901 4.45401 13.7639 6.86304 13.9315 9.3763H17.6834C17.4034 5.88667 14.7993 3.05275 11.42 2.42348ZM12.6784 9.3763C12.4965 6.90486 11.5613 4.54841 10.0001 2.62526C8.4389 4.54841 7.50368 6.90486 7.32172 9.3763H12.6784ZM7.32172 10.6263H12.6784C12.4965 13.0978 11.5613 15.4542 10.0001 17.3774C8.43889 15.4542 7.50367 13.0978 7.32172 10.6263ZM6.06865 10.6263H2.31672C2.59672 14.1159 5.20083 16.9498 8.5801 17.5791C7.11002 15.5486 6.2363 13.1396 6.06865 10.6263ZM11.4201 17.5791C12.8901 15.5486 13.7639 13.1396 13.9315 10.6263H17.6834C17.4034 14.1159 14.7993 16.9498 11.4201 17.5791Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomains);
export default __webpack_public_path__ + "static/media/domains.853ea286841adb54d3f74d095fbc1226.svg";
export { ForwardRef as ReactComponent };